import { isLocalhostDevMode } from "@/utils/utils";
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";

interface PartnerSsoState {
  ssoState?: string;
  actions: {
    ssoLoginStarted: (ssoState: string) => void;
    ssoCallbackReceived: (ssoState: string) => boolean;
  };
}

/**
 * The OAuth state sent to the partner's login. Persisted, because the partner redirects back into a new tab.
 */
const usePartnerSsoStore = create<PartnerSsoState>()(
  devtools(
    persist(
      (set, get) => ({
        ssoState: undefined,
        actions: {
          ssoLoginStarted: (ssoState) => set({ ssoState }),
          // The state is single use, so a replayed callback URL is rejected.
          ssoCallbackReceived: (ssoState) => {
            if (get().ssoState !== ssoState) {
              return false;
            }

            set({ ssoState: undefined });

            return true;
          },
        },
      }),
      {
        name: "cliip:partner-sso",
        storage: createJSONStorage(() => localStorage),
        partialize: (state) => ({ ssoState: state.ssoState }),
      },
    ),
    { name: "partnerSso", enabled: isLocalhostDevMode() },
  ),
);

export const usePartnerSsoState = () => usePartnerSsoStore((state) => state.ssoState);

export const usePartnerSsoActions = () => usePartnerSsoStore((state) => state.actions);
